import React from 'react'
import { Avatar, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const BlogListItem = ({ blog }: any) => {
    return (
        <ListItem disablePadding>
            <ListItemButton component="a" href={`/blog/${blog.blog_id}`}>
                <ListItemAvatar>
                    {blog.image ? (
                        <Avatar
                            variant="square"
                            sx={{
                                width: 96,
                                height: 54,
                                bgcolor: '#FFF',
                            }}
                        >
                            <GatsbyImage alt={blog.blog_id} image={getImage(blog.image)!} />
                        </Avatar>
                    ) : (
                        <Avatar variant="square" sx={{ width: 96, height: 54 }}>
                            {blog.blog_id.substring(0, 1).toUpperCase()}
                        </Avatar>
                    )}
                </ListItemAvatar>
                <ListItemText
                    inset={true}
                    primary={blog.site}
                    primaryTypographyProps={{
                        fontSize: 24,
                    }}
                />
            </ListItemButton>
        </ListItem>
    )
}

export default BlogListItem
